import React, { useContext, useState } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { Badge, Button, Card, CardContent } from "@material-ui/core";
import AuthContext from "../../../hooks/authContext";
import styles from "../Accounts.module.scss";
import { DowngradeDetailsDialog } from "./PaymentSuccess";
import { CommonConfirmationDialog } from "../../../components/DialogComponent/SupplyDataDialog";
import { useToast } from "../../../hooks/useToast";
import { useMediaQuery } from "@mui/material";
import { packageAccess } from "../../../services/helpers";
import { PartnerBenefitsModal } from "./PartnerBenefitsModal";
// import PaymentMethodsList from "./PaymentMethodsList";

const SubscriptionList = (props) => {
    const {
      prices,
      isAnnual,
      yearlyPrice,
      numUsers,
      setNewPrice,
      setNewProduct,
      newProduct,
      setNewPriceId,
      handleUpdateStripeSubscription,
      loader,
      priceState,
      customerBalance,
      newPrice,
      setPlanInfo,
      isFullDiscount
    } = props;
                  
  const auth = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const { toast } = useToast();
  const [renewOpen, setRenewOpen] = useState(false);
  const [showBenefitsModal, setShowBenefitsModal] = useState(false);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isPending = auth?.userProfile?.pendingVerifications?.length > 0 && auth?.userProfile?.pendingVerifications?.[0]?.status === "pending";
  const customerCode = auth?.userProfile?.userPromoCode;

  const handleDialogOpen = (priceId, productId) => {
    if(auth?.userProfile?.subscriptions?.data?.length > 0){
      const currentSub = auth?.userProfile?.subscriptions?.data?.[0];
      const oldPriceAmount = currentSub?.plan?.amount;
      
      const allPrices = [...(prices || []), ...(yearlyPrice || [])];
      const newPriceObj = allPrices?.find(p => p?.id === priceId);
      const newPriceAmount = newPriceObj?.unit_amount;
      
      // if (newPriceId === oldPriceId) {
      //   setRenewOpen(true);
      //   return;
      // } else 
      if (newPriceAmount < oldPriceAmount) {
        setOpen(true);
        return;
      } else {
        handleUpdateStripeSubscription(priceId, productId);
      }
    } else {
      handleUpdateStripeSubscription(priceId, productId);
    }
  };

  const handleCloseDialog = () => {
    setOpen(false);
  }

  const handleConfirmDialog = () => {
    setOpen(false);
    handleUpdateStripeSubscription(newPrice, newProduct);
  }

  const handleRenewConfirm = () => {
    setRenewOpen(false);
    handleUpdateStripeSubscription(newPrice, newProduct);
  }

  const handleRenewClose = () => {
    setRenewOpen(false);
  }

  function getPriceDisplay(priceId) {
    const priceObj = prices?.find((p) => p.id === priceId);
    if (!priceObj) return null;
    const adjustedAmount = priceObj.unit_amount * 10;
    // const oldAmount = (adjustedAmount / 100).toFixed(2);
    const oldAmount = priceObj.unit_amount;
    const newAmount = (adjustedAmount / 12 / 100).toFixed(2);
    return { oldAmount, newAmount };
  }

  const getPriceInfo = (planName) => {
     const monthlyPriceObj = prices?.find(p => p.product.name === planName);
     const yearlyPriceObj = yearlyPrice?.find(p => p.product.name === planName);
     
     if (!monthlyPriceObj || !yearlyPriceObj) return null;
     
      const savedAmount = (monthlyPriceObj.unit_amount * 12 - yearlyPriceObj.unit_amount).toFixed(2) / 100;
     return {
        oldAmount: monthlyPriceObj.unit_amount,
        newAmount: (yearlyPriceObj.unit_amount / 12 / 100).toFixed(2),
        savedAmount: savedAmount
     };
  };

  const formatStripeAmount = (amount) => {
    return `$${(amount / 100).toFixed(0)}`;
  };

  const currentPlanId = auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id;
  const subscriptionStatus = auth?.userProfile?.subscriptionDetails?.status;
  const currentPeriodEnd = auth?.userProfile?.subscriptionDetails?.current_period_end;
  const currentPeriodEndDate = new Date(currentPeriodEnd * 1000);
  const today = new Date();
  const diffInDays = (currentPeriodEndDate - today) / (1000 * 60 * 60 * 24);
  // eslint-disable-next-line no-unused-vars
  const isExpiringSoon = subscriptionStatus === "active" && (diffInDays <= 5 && diffInDays >= 0);


  return (
    <>
    <div className={isMobile ? `${styles.gridWrapper} mt-20` : `${styles.gridWrapper} mt-20 p-20`}>
      {isAnnual === true &&
        yearlyPrice?.map((plan) => {
          const priceInfo = getPriceInfo(plan?.product?.name);
          const price = priceState?.[plan?.product?.name]?.yearly;
          const isCurrentPlanActive = currentPlanId === plan?.id && subscriptionStatus === "active";
          const allowedPermissions = packageAccess(plan?.product?.id);

          return (
            <Card
              className={`${styles.cardUpgrade} ${
                plan?.product?.name === "Plus" ? styles.popular : ""
              } dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white`}
            >
              <div className={styles.badgeWrapper}>
                {plan?.product?.name === "Plus" && (
                  <div className={styles.popularBadge}>
                    <Badge className={styles.badge}>Most popular</Badge>
                  </div>
                )}
              </div>

              <CardContent className="p-20">
                <div className="d-flex flex-space-between">
                  <div>
                    <h3 className="text-xl font-bold text-foreground">
                      {plan?.product?.name}
                    </h3>
                    <p className="text-base font-bold text-foreground leading-tight mv-5">
                      {plan?.product?.description}
                    </p>
                    <p className="text-lg font-extrabold text-green-600 dark:text-green-500 leading-tight mb-20">
                      Up to {allowedPermissions?.userLimit || 5} Employees
                    </p>
                    <div className={styles.priceRow}>
                      <span className={styles.price}>
                        {plan?.product?.name === "Users Plan" && numUsers > 1
                          ? formatStripeAmount(
                              (price || plan?.unit_amount) * numUsers
                            )
                          : price
                          ? formatStripeAmount(price)
                          : isFullDiscount ? `$0` : `$${priceInfo?.newAmount}`}
                      </span>
                      <span>
                        {plan?.product?.name === "Users Plan"
                          ? "/month per user"
                          : "/month"}
                      </span>
                    </div>
                  </div>
                  {/* {plan?.product?.name === "Users Plan" && (
                          <div className="d-flex flex-direction-column flex-center mt-1">
                            <h4 className="mb-8">QTY : </h4>
                            <input
                              id="numUsers"
                              type="number"
                              min="1"
                              value={numUsers}
                              onChange={(e) =>
                                setNumUsers(parseInt(e.target.value) || 1)
                              }
                              style={{ width: "90px", fontSize:"20px", fontWeight:"700", color:"#020817", border:"1px solid hsl(214.3, 31.8%, 91.4%)", borderRadius:"4px" }}
                            />
                            <span className="mt-5">
                              {numUsers} x{" "}
                              {price
                                ? formatStripeAmount(price)
                                : formatStripeAmount(plan?.unit_amount)}{" "}
                              per user
                            </span>
                          </div>
                        )} */}
                </div>
                <div className="mb-20">
                 <div className="space-y-1">
                  <p className="text-sm text-gray-500">
                    Billed Annually
                  </p>

                  <p className="text-sm font-semibold text-green-600">
                    Save ${priceInfo?.savedAmount}/year vs monthly
                  </p>
                </div>
                  {/* {priceInfo && (
                    <>
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "#666",
                        }}
                      >
                        {formatStripeAmount(priceInfo?.oldAmount)}/month
                      </span>{" "}
                      <span style={{ color: "#27ae60", fontWeight: "bold" }}>
                        ${priceInfo?.newAmount}/month
                      </span>
                    </>
                  )} */}
                </div>
                <Button
                  disabled={
                    loader === true || isCurrentPlanActive
                  }
                  className={`${
                    auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id ===
                      plan?.id &&
                    auth?.userProfile?.subscriptionDetails?.status === "active"
                      ? styles.buttonDisabled
                      : styles.button
                  } ${
                    plan?.product?.name === "Users Plan"
                      ? styles.primaryButton
                      : ""
                  }`}
                  onClick={() => {
                    // if (isCurrentPlanActive && !isExpiringSoon) {
                    //     return;
                    // }  else
                    if (isPending) {
                      toast?.({
                        title: "Verification Required",
                        description: "Please verify your bank account first. You cannot change the plan until verification is complete.",
                        variant: "destructive",
                      });
                      return;
                    }

                    if (plan?.product?.name === "Users Plan") {
                      setNewPrice(plan?.id);
                      setNewPriceId(plan?.id);
                    } else {
                      handleDialogOpen(plan?.id, plan?.product?.id);
                      setNewPrice(plan?.id);
                      setNewProduct(plan?.product?.id);
                      setPlanInfo({planName: plan?.product?.name, description: plan?.product?.description, amount: plan?.unit_amount, yearly: true});
                    }
                  }}
                >
                  {/* {isCurrentPlanActive ? isExpiringSoon ? "Renew Plan" : "Current Plan" : "Select This Plan"} */}
                  {isCurrentPlanActive ? "Current Plan" : "Select This Plan"}
                </Button>

                <div className="mt-20">
                  <div className={styles.featureTitle}>This includes:</div>
                  <ul className={styles.featureList}>
                    {plan?.product?.marketing_features?.map(
                      (feature, index) => (
                        <li key={index} className={styles.featureItem}>
                          <CheckOutlinedIcon
                            fontSize="small"
                            className={styles.icon}
                          />
                          <span className="dark:text-white text-[#020817]">
                            {feature.name}
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                </div>

              {(isFullDiscount || !!customerCode) && (
                <div className="mt-12 pt-12 border-t border-border flex flex-col items-center gap-2">
                  <Badge className="ph-10 pv-5 rounded-full bg-amber-100 text-amber-800 hover:bg-amber-100 dark:bg-amber-900/30 dark:text-amber-400 dark:hover:bg-amber-900/30 font-medium text-xs">
                    🏆 Founding Partner
                  </Badge>
                  <button
                    onClick={() => setShowBenefitsModal(true)}
                    className="text-xs text-green-600 dark:text-green-500 hover:text-green-700 dark:hover:text-green-400 font-medium transition-colors underline"
                  >
                    View partner benefits
                  </button>
                </div>
              )}
              </CardContent>
            </Card>
          );
        })}

      {isAnnual !== true &&
        prices?.map((plan) => {
          const price = priceState?.[plan?.product?.name]?.monthly;
          const isCurrentPlanActive = currentPlanId === plan?.id && subscriptionStatus === "active";
          const allowedPermissions = packageAccess(plan?.product?.id);
          return (
            <Card
              className={`${styles.cardUpgrade} ${
                plan?.product?.name === "Plus" ? styles.popular : ""
              } dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white`}
            >
              <div className={styles.badgeWrapper}>
                {plan?.product?.name === "Plus" && (
                  <div className={styles.popularBadge}>
                    <Badge className={styles.badge}>Most popular</Badge>
                  </div>
                )}
              </div>

              <CardContent className="p-20">
                <div className="d-flex flex-space-between">
                <div>
                    <h3 className="text-xl font-bold text-foreground">
                      {plan?.product?.name}
                    </h3>
                    <p className="text-base font-bold text-foreground leading-tight mv-5">
                      {plan?.product?.description}
                    </p>
                    <p className="text-lg font-extrabold text-green-600 dark:text-green-500 leading-tight mb-20">
                      Up to {allowedPermissions?.userLimit || 5} Employees
                    </p>
                    <div className={styles.priceRow}>
                      <span className={styles.price}>
                        {isFullDiscount ? `$0` : plan?.product?.name === "Users Plan" && numUsers > 1
                          ? formatStripeAmount(
                              (price || plan?.unit_amount) * numUsers
                            )
                          : price
                          ? formatStripeAmount(price)
                          : formatStripeAmount(plan?.unit_amount)}
                      </span>
                      <span>
                        {plan?.product?.name === "Users Plan"
                          ? "/month per user"
                          : "/month"}
                      </span>
                    </div>
                  </div>
                  {/* {plan?.product?.name === "Users Plan" && (
                          <div className="d-flex flex-direction-column flex-center mt-1">
                            <h3 className="mb-8">QTY : </h3>
                            <input
                              id="numUsers"
                              type="number"
                              min="1"
                              value={numUsers}
                              onChange={(e) =>
                                setNumUsers(parseInt(e.target.value) || 1)
                              }
                              style={{ width: "90px", fontSize:"20px", fontWeight:"700", color:"#020817", border:"1px solid hsl(214.3, 31.8%, 91.4%)", borderRadius:"4px" }}
                            />
                            <span className="mt-5">
                              {numUsers} x{" "}
                              {price
                                ? formatStripeAmount(price)
                                : formatStripeAmount(plan?.unit_amount)}{" "}
                              per user
                            </span>
                          </div>
                        )} */}
                </div>
                 {/* loader === true || (isCurrentPlanActive && !isExpiringSoon) */}
                <Button
                  disabled={
                    loader === true || isCurrentPlanActive
                  }
                  className={`${
                    auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id ===
                      plan?.id &&
                    auth?.userProfile?.subscriptionDetails?.status === "active"
                      ? styles.buttonDisabled
                      : styles.button
                  } ${
                    plan?.product?.name === "Users Plan"
                      ? styles.primaryButton
                      : ""
                  }`}
                  onClick={() => {
                    // if (isCurrentPlanActive && !isExpiringSoon) {
                    //     return;
                    // } else
                    if (isPending) {
                      toast?.({
                        title: "Verification Required",
                        description: "Please verify your bank account first. You cannot change the plan until verification is complete.",
                        variant: "destructive",
                      });
                      return;
                    }

                    if (plan?.product?.name === "Users Plan") {
                      setNewPrice(plan?.id);
                      setNewPriceId(plan?.id);
                    } else {
                      handleDialogOpen(plan?.id, plan?.product?.id);
                      setNewPrice(plan?.id);
                      setNewProduct(plan?.product?.id);
                      setPlanInfo({planName: plan?.product?.name, description: plan?.product?.description, amount: plan?.unit_amount, yearly: false});
                    }
                  }}
                >
                  {/* {isCurrentPlanActive ? isExpiringSoon ? "Renew Plan" : "Current Plan" : "Select This Plan"} */}
                  {isCurrentPlanActive ? "Current Plan" : "Select This Plan"}
                </Button>

                <div className="mt-20">
                  <div className={styles.featureTitle}>This includes:</div>
                  <ul className={styles.featureList}>
                    {plan?.product?.marketing_features?.map(
                      (feature, index) => (
                        <li key={index} className={styles.featureItem}>
                          <CheckOutlinedIcon
                            fontSize="small"
                            className={styles.icon}
                          />
                          <span className="dark:text-white text-[#020817]">
                            {feature.name}
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                </div>

              {(isFullDiscount || !!customerCode) && (
                <div className="mt-12 pt-12 border-t border-border flex flex-col items-center gap-2">
                  <Badge className="ph-10 pv-5 rounded-full bg-amber-100 text-amber-800 hover:bg-amber-100 dark:bg-amber-900/30 dark:text-amber-400 dark:hover:bg-amber-900/30 font-medium text-xs">
                    🏆 Founding Partner
                  </Badge>
                  <button
                    onClick={() => setShowBenefitsModal(true)}
                    className="text-xs text-green-600 dark:text-green-500 hover:text-green-700 dark:hover:text-green-400 font-medium transition-colors underline"
                  >
                    View partner benefits
                  </button>
                </div>
              )}
              </CardContent>
            </Card>
          );
        })}
    </div>

    {showBenefitsModal && (
      <PartnerBenefitsModal 
        isOpen={showBenefitsModal}
        onClose={() => setShowBenefitsModal(false)}
      />
    )}

    {open && (
      <DowngradeDetailsDialog  
      open={open}
      onConfirm={handleConfirmDialog}
      onClose={handleCloseDialog}
      data={auth?.userProfile}
      balance={customerBalance}
      newPrice={newPrice}
      allPrices={[...(prices || []), ...(yearlyPrice || [])]}
      />
    )}

    {renewOpen && (
      <CommonConfirmationDialog  
        open ={renewOpen}
        onConfirm={handleRenewConfirm}
        onClose={handleRenewClose} 
        title={"Renew Current Plan"}
        message={"You are about to renew your current subscription. The payment will be deducted automatically from your default payment method."} 
      />
    )}
    </>
  );
};

export default SubscriptionList;
